module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', {
    staticStyle: {
      "background-color": "#f9fbff"
    },
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.GtrGenesArr.length === 0 && _vm.PhenolyzerGenesArr.length === 0 && _vm.manuallyAddedGenes.length === 0) ? _c('div', [_c('v-card-text', [_c('center', [_c('h3', [_vm._v(_vm._s(_vm.IntroductionTextData.Title))])])], 1), _vm._v(" "), _c('center', [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.IntroductionTextData.Content)
    }
  })], 1)], 1) : (_vm.GtrGenesArr.length > 1 || _vm.PhenolyzerGenesArr.length > 1 || _vm.manuallyAddedGenes.length > 0) ? _c('div', [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card-text', [_c('strong', [_vm._v("GTR Conditions:")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.GtrGenesArr.length === 0) ? _c('div', [_c('v-chip', {
    attrs: {
      "color": "orange",
      "text-color": "white",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("error_outline")]), _vm._v("\n                              No conditions\n                           ")], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.GtrSearchTerms), function(searchItem, i) {
    return (_vm.GtrGenesArr.length > 0) ? _c('v-chip', {
      key: i,
      attrs: {
        "disabled": "",
        "color": "primary",
        "text-color": "white"
      }
    }, [_vm._v("\n                          " + _vm._s(i + 1) + ". " + _vm._s(searchItem) + "\n                        ")]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('v-flex', [_c('v-card-text', [_c('strong', [_vm._v("Phenolyzer:")]), _vm._v(" "), (_vm.PhenolyzerSearchTerms.length > 0) ? _c('div', _vm._l((_vm.PhenolyzerSearchTerms), function(searchItem, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "disabled": "",
        "color": "primary",
        "text-color": "white"
      }
    }, [_vm._v("\n                          " + _vm._s(i + 1) + ". " + _vm._s(searchItem) + "\n                        ")])
  })) : _c('div', [_c('v-chip', {
    attrs: {
      "color": "orange",
      "text-color": "white",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("error_outline")]), _vm._v("\n                            No phenotypes searched\n                         ")], 1)], 1)])], 1)], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": "",
      "lg8": ""
    }
  }, [_c('v-card', [_c('SummaryDataTable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.GtrGenesArr.length > 1 || _vm.PhenolyzerGenesArr.length > 1 || _vm.manuallyAddedGenes.length > 0),
      expression: "GtrGenesArr.length>1 || PhenolyzerGenesArr.length>1 || manuallyAddedGenes.length>0"
    }],
    attrs: {
      "geneSearch": _vm.geneSearch,
      "summaryTableData": _vm.summaryTableArray
    },
    on: {
      "TotalSummaryGenes": function($event) {
        _vm.TotalSummaryGenes($event)
      },
      "TotalSummarySelectedGenes": function($event) {
        _vm.TotalSummarySelectedGenes($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    class: [(_vm.browser === 'Chrome' && _vm.isMobile === false) || (_vm.browser === 'Firefox' && _vm.isMobile === false) ? 'flex xs12 sm12 md4 lg4 pr-2 pl-2' : 'flex xs12 sm12 md2 lg3 pr-2 pl-2']
  }, [_c('div', {
    staticClass: "d-flex mb-2 xs12"
  }, [(_vm.GtrGenesArr.length > 1 || _vm.PhenolyzerGenesArr.length > 1 || _vm.manuallyAddedGenes.length > 0) ? _c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search for Gene",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.geneSearch),
      callback: function($$v) {
        _vm.geneSearch = $$v
      },
      expression: "geneSearch"
    }
  })], 1), _vm._v(" "), _c('br')], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-3 mb-2 xs12"
  }, [(_vm.GtrGenesArr.length > 1 || _vm.PhenolyzerGenesArr.length > 1) ? _c('v-card', {
    class: [_vm.chartComponent === null ? 'activeCardBox' : 'rightbarCard']
  }, [_c('v-card-text', [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading"
  }, [_vm._v("\n                      GENES SUMMARY\n                      ")]), _vm._v(" "), _c('Dialogs', {
    staticClass: "dialogBox",
    attrs: {
      "id": "genesDialog",
      "HeadlineText": _vm.HelpDialogsData[5].HeadlineText,
      "ContentText": _vm.HelpDialogsData[5].Content
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [(!_vm.openEditBox) ? _c('span', [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selectedGenes))])]) : _c('span', [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "padding-top": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.genesTop),
      expression: "genesTop"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "8px",
      "width": "82%"
    },
    attrs: {
      "id": "top-genes-summary",
      "type": "text",
      "placeholder": "10",
      "autocomplete": "off",
      "list": "genes"
    },
    domProps: {
      "value": (_vm.genesTop)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.genesTop = $event.target.value
      }
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "genes"
    }
  }, _vm._l((_vm.genesTopCounts), function(genesCount) {
    return _c('option', [_vm._v("\n                                   " + _vm._s(genesCount) + "\n                                 ")])
  }))])]), _vm._v("\n                         of " + _vm._s(_vm.totalGenes) + " genes selected\n                         "), (!_vm.openEditBox) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        _vm.openEditBox = true
      }
    },
    slot: "activator"
  }, [_vm._v("\n                            edit\n                          ")]), _vm._v(" "), _c('span', [_vm._v("Edit the number of genes selected")])], 1) : _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        _vm.openEditBox = false
      }
    },
    slot: "activator"
  }, [_vm._v("\n                           close\n                         ")]), _vm._v(" "), _c('span', [_vm._v("Close the edit box")])], 1)], 1)], 1), _vm._v(" "), (_vm.totalGenes) ? _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "genesSvgBox",
      "selectedNumber": _vm.selectedGenes,
      "totalNumber": _vm.totalGenes
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.GtrGenesArr.length > 1 && _vm.PhenolyzerGenesArr.length > 1) ? _c('div', _vm._l((_vm.pieChartdataArr), function(item, i) {
    return _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "Rightbar_card_content_subheading",
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_vm._v("\n                             " + _vm._s(item.name) + "\n                           ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', [(_vm.totalGenes) ? _c('SummarySvgBar', {
      staticClass: "SvgBarClass",
      attrs: {
        "id": "genesbar",
        "selectedNumber": item.count,
        "totalNumber": _vm.totalGenes
      }
    }) : _vm._e()], 1)])], 1)
  })) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('br')])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fbc41e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/SummaryTab.vue
// module id = 498
// module chunks = 0